import React from "react";
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Input } from '../../UI/InputElement/InputElement';
let Search = (props) => {
  const { onAreaChange, handleSubmit, handleFilter, reset } = props;
  const noOptionsMessage = (a, b) => {
    return 'Area not found';
  }

  return(
        <form className="mobile-view-history" onSubmit={handleSubmit(handleFilter)}>
          <div className="card-body">
            <div className="row justify-content-center align-items-end">
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-3">
                <label className="form_title">Area Name</label>
                <Input name="area_name" type="inputGroupSelect" className="w-100" noOptionsMessage={noOptionsMessage} options={(props.areas || []).map(area => {return {value: area.id, label: area.name}})} placeholder="AREA-NAME" />
              </div>
        
              <div className="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-12 mb-3">
                <label className="w-100 d-block mb-0 position-relative">
                  <Input name="start_date" dateFormat="MM-dd-yyyy" placeholder="Start Date" datePickerType={"react-datepicker"} type="date" className="form-control input-modifier w-100" />
                  <div className="input-group-append cst_group_append" style={{ right: '0px' }}>
                    <span className="input-group-text" id="basic-addon2"><i className="fa fa-calendar"></i></span>
                  </div>
                </label>
              </div>

              <div className="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-12 mb-3">
                <label className="w-100 d-block mb-0 position-relative">
                  <Input name="end_date" dateFormat="MM-dd-yyyy" placeholder="End Date" datePickerType={"react-datepicker"} type="date" className="form-control input-modifier w-100" />
                  <div className="input-group-append cst_group_append" style={{ right: '0px' }}>
                    <span className="input-group-text" id="basic-addon2"><i className="fa fa-calendar"></i></span>
                  </div>
                </label>
              </div>

              <div className="col-xl-3 col-lg-12 col-md-6 col-sm-12 col-12 mb-3">
                <div className="d-flex align-items-center justify-content-start flex-nowrap" style={{ gap: '15px' }}>
                  <button style={{ minWidth: '90px' }} className="btn cst_btn btn_danger account_btn m-0" id="submit" type="submit">{"Go"}</button>
                  <button style={{ minWidth: '90px' }} className="btn cst_btn btn-outline-secondary account_btn m-0" onClick={reset} id="reset" type="button">{"Reset"}</button>
                </div>
              </div>
            </div>
          </div>
        </form>
  )
};
Search = reduxForm({
  form: 'historySearch'
})(Search);

Search = connect(null)(Search);
export default Search;